export default __webpack_public_path__ + "static/media/M1A_7.a2cbdb71.png";